import {
    getAllCargoTemperatureConfigsItems,
    getAllCargoTemperatureLogItems,
    deleteCargoTemperatureConfigsItem,
    deleteCargoTemperatureLogItem,
} from 'src/api/cargo-temp-log/offlineCargoTempLogApi';
import useSyncHelper from './useSyncHelper';

const useSyncOfflineCargoTempLog = () => {
    const { syncItems } = useSyncHelper();

    const syncCargoTemperatureConfigsItems = async () =>
        await syncItems(
            getAllCargoTemperatureConfigsItems,
            deleteCargoTemperatureConfigsItem,
            ['saveCargoTemperatureConfigsRequest'],
            'saveCargoTemperatureConfigsId'
        );

    const syncCargoTemperatureLogItems = async () =>
        await syncItems(getAllCargoTemperatureLogItems, deleteCargoTemperatureLogItem, ['saveCargoTemperatureLogRequest'], 'logDate');

    const syncOfflineCargoTempLog = async () => {
        await syncCargoTemperatureConfigsItems();
        await syncCargoTemperatureLogItems();
    };

    return {
        syncOfflineCargoTempLog,
    };
};

export default useSyncOfflineCargoTempLog;
